//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReCaptcha from 'vue-recaptcha'
import { required, sameAs, email } from 'vuelidate/lib/validators'
export default {
  name: 'Form',
  components: {
    ReCaptcha
  },
  data () {
    return {
      displayResume: false,
      autocompleteKey: process.env.PLACE_AUTOCOMPLETE_KEY,
      form: {
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        address: '',
        message: '',
        captcha: false,
        rgpd: false,
        addressMoreInformation: '',
        postalCode: ''
      },
      siteKey: '',
      mappingCPSelas: [
        // -- SIPATH
        { cp: '01', email: 'sipath.commande@orange.fr' },
        { cp: '03', email: 'sipath.commande@orange.fr' },
        { cp: '07', email: 'sipath.commande@orange.fr' },
        { cp: '15', email: 'sipath.commande@orange.fr' },
        { cp: '26', email: 'sipath.commande@orange.fr' },
        { cp: '38', email: 'sipath.commande@orange.fr' },
        { cp: '42', email: 'sipath.commande@orange.fr' },
        { cp: '43', email: 'sipath.commande@orange.fr' },
        { cp: '63', email: 'sipath.commande@orange.fr' },
        { cp: '69', email: 'sipath.commande@orange.fr' },
        { cp: '73', email: 'sipath.commande@orange.fr' },
        { cp: '74', email: 'sipath.commande@orange.fr' },
        { cp: '18', email: 'sipath.commande@orange.fr' },
        { cp: '36', email: 'sipath.commande@orange.fr' },
        { cp: '41', email: 'sipath.commande@orange.fr' },
        { cp: '45', email: 'sipath.commande@orange.fr' },
        { cp: '19', email: 'sipath.commande@orange.fr' },
        { cp: '23', email: 'sipath.commande@orange.fr' },
        // ----- Abbeville
        { cp: '28', email: 'juliette.binoist@unilabs.fr' },
        { cp: '60', email: 'juliette.binoist@unilabs.fr' },
        { cp: '80', email: 'juliette.binoist@unilabs.fr' },
        { cp: '14', email: 'juliette.binoist@unilabs.fr' },
        { cp: '27', email: 'juliette.binoist@unilabs.fr' },
        { cp: '50', email: 'juliette.binoist@unilabs.fr' },
        { cp: '61', email: 'juliette.binoist@unilabs.fr' },
        { cp: '76', email: 'juliette.binoist@unilabs.fr' },
        // ----- Bordeaux
        { cp: '16', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '17', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '24', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '32', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '33', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '40', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '47', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '64', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '79', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '85', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '86', email: 'commandes.ihcp@unilabs.fr' },
        { cp: '87', email: 'commandes.ihcp@unilabs.fr' },
        // ----- Lille
        { cp: '08', email: 'logistique.pnu@gmail.com' },
        { cp: '10', email: 'logistique.pnu@gmail.com' },
        { cp: '51', email: 'logistique.pnu@gmail.com' },
        { cp: '52', email: 'logistique.pnu@gmail.com' },
        { cp: '54', email: 'logistique.pnu@gmail.com' },
        { cp: '55', email: 'logistique.pnu@gmail.com' },
        { cp: '57', email: 'logistique.pnu@gmail.com' },
        { cp: '67', email: 'logistique.pnu@gmail.com' },
        { cp: '68', email: 'logistique.pnu@gmail.com' },
        { cp: '88', email: 'logistique.pnu@gmail.com' },
        { cp: '02', email: 'logistique.pnu@gmail.com' },
        { cp: '59', email: 'logistique.pnu@gmail.com' },
        { cp: '62', email: 'logistique.pnu@gmail.com' },
        // ----- Paris
        { cp: '75', email: process.env.RECOVERY_EMAIL },
        { cp: '78', email: process.env.RECOVERY_EMAIL },
        { cp: '91', email: process.env.RECOVERY_EMAIL },
        { cp: '92', email: process.env.RECOVERY_EMAIL },
        { cp: '93', email: process.env.RECOVERY_EMAIL },
        { cp: '94', email: process.env.RECOVERY_EMAIL },
        { cp: '95', email: process.env.RECOVERY_EMAIL },
        { cp: '77', email: process.env.RECOVERY_EMAIL }
      ]
    }
  },
  created () {
    this.siteKey = process.env.GOOGLE_RECAPTCHA_KEY
  },
  mounted () {
    this.initAutocomplete().then(this.handlePlaceSelection).catch(this.handleError)
  },
  methods: {
    initAutocomplete () {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.autocomplete = new window.google.maps.places.Autocomplete(
            (this.$refs.autocomplete),
            { types: ['geocode'] }
          )
          resolve()
        }, 1000)
      })
    },
    getEmailByPostalCode (code) {
      if (!code) { return process.env.RECOVERY_EMAIL }

      const mainCode = code.substring(0, 2)
      const mapping = this.mappingCPSelas.find(m => m.cp === mainCode)
      if (mapping) {
        return mapping.email
      }
      return process.env.RECOVERY_EMAIL
    },
    handlePlaceSelection () {
      this.autocomplete.addListener('place_changed', () => {
        console.log('place change')
        this.form.postalCode = null
        let place = this.autocomplete.getPlace()
        console.log('place --> ', place)
        let ac = place.address_components
        this.form.address = place.formatted_address
        const postalItem = ac.find(c => c.types.find(t => t === 'postal_code'))
        const country = ac.find(c => c.types.find(t => t === 'country'))
        if (postalItem && country && country.short_name === 'FR') {
          let postal = postalItem.long_name
          console.log('code postal ->', postal)
          this.form.postalCode = postal
        }
      })
    },
    handleError (error) {
      console.log('erorr', error)
    },
    onRecaptchaVerify (response) {
      this.form.captcha = true
    },
    onRecaptchaExpired () {
      console.log('Captcha expired')
      this.form.captcha = false
    },
    submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$error && this.form.postalCode) {
        var data = {
          'email_to': this.getEmailByPostalCode(this.form.postalCode),
          'reply_to': this.form.email,
          'code_postal': this.form.postalCode,
          'name': this.form.lastname,
          'prenom': this.form.firstname,
          'email': this.form.email,
          'phone': this.form.phone,
          'adresse': this.form.address,
          'adresse_more_information': this.form.addressMoreInformation,
          'message': this.form.message
        }
        window.emailjs.send('smtp_server', 'template_1d9CQKVO', data)
        console.log(data)
        this.displayResume = true
      }
    }
  },
  validations: {
    form: {
      email: {
        email,
        required
      },
      firstname: {
        required,
        minLength: 2
      },
      lastname: {
        required,
        minLength: 2
      },
      phone: { required },
      address: { required, minLength: 2 },
      captcha: { required, sameAsCaptcha: sameAs(() => true) },
      rgpd: { required, sameAsCaptcha: sameAs(() => true) }
    }
  }
}
